class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.onClickHandler = this.onClickHandler.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);

    this.addEventListener('click', this.onClickHandler);

    if (this.dataset.trigger === 'infinite') {
      this.observer = new IntersectionObserver(this.handleIntersection, {
        rootMargin: '0px 0px 200px 0px'
      });
      this.observer.observe(this);
    }
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.onClickHandler();
  }

  async onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;

    const url = this.dataset.url;
    if (!url) return;

    this.classList.add('loading');
    this.classList.add('disabled');

    try {
      await InfiniteScroll.renderSectionFromFetch(url);
    } catch (error) {
      console.error('Infinite scroll error:', error);
      this.classList.remove('disabled');
    } finally {
      this.classList.remove('loading');
    }
  }

  static async renderSectionFromFetch(url) {
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) {
      throw new Error(`Fetch failed: ${response.status}`);
    }

    const responseText = await response.text();
    const parsed = new DOMParser().parseFromString(responseText, 'text/html');

    InfiniteScroll.renderProductGridContainer(parsed);
    InfiniteScroll.renderPagination(parsed);
  }

  static renderPagination(parsedDoc) {
    const currentGridContainer = document.getElementById('ProductGridContainer');
    const newGridContainer = parsedDoc.getElementById('ProductGridContainer');

    if (!currentGridContainer || !newGridContainer) return;

    const currentPagination = currentGridContainer.querySelector('.pagination-wrapper');
    const newPagination = newGridContainer.querySelector('.pagination-wrapper');

    if (newPagination && currentPagination) {
      currentPagination.innerHTML = newPagination.innerHTML;
      return;
    }

    if (newPagination && !currentPagination) {
      currentGridContainer.insertAdjacentHTML('beforeend', newPagination.outerHTML);
      return;
    }

    if (!newPagination && currentPagination) {
      currentPagination.remove();
    }
  }

  static renderProductGridContainer(parsedDoc) {
    const currentGrid = document.getElementById('product-grid');
    const newGrid = parsedDoc.getElementById('product-grid');

    if (!currentGrid || !newGrid) {
      throw new Error('Product grid not found in current or fetched HTML');
    }

    currentGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
  }
}

customElements.define('infinite-scroll', InfiniteScroll);